module.exports = __webpack_public_path__ + "static/media/h-chat.5ca598c8.svg";